import {AppVersion} from '../../types/AppVersion';
import {AppFilterStrategy} from './AppFilterStrategy';
import {VendorMapper, VendorType} from '../../utils/VendorMapper';

/**
 * Filter strategy for filtering apps by vendor type (Optimizely vs Partner).
 * Uses VendorMapper to normalize vendor strings to canonical types.
 */
export class VendorFilterStrategy extends AppFilterStrategy<VendorType> {
  public matches(app: AppVersion, filterValue: VendorType | undefined): boolean {
    if (!this.isActive(filterValue)) {
      return true;
    }

    const normalizedVendor = VendorMapper.normalize(app.metadata.vendor);
    return normalizedVendor === filterValue;
  }
}
